import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { ModuleClient } from 'projects/access-control/src/app/Domain/Entities/module-client.interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { createAction, props } from '@ngrx/store';

export const getClient = createAction('[CLIENT] get client ');
export const getClientSuccess = createAction(
	'[CLIENT] get client success',
	props<{ client: Client[] }>()
);
export const getClientError = createAction('[CLIENT] get client error', props<{ error: any }>());

export const searchClient = createAction('[CLIENT] search client', props<{ search: string }>());
export const searchClientSuccess = createAction(
	'[CLIENT] search client success',
	props<{ client: Client[] }>()
);
export const searchClientError = createAction(
	'[CLIENT] search client error',
	props<{ error: any }>()
);

export const postClient = createAction('[CLIENT] Post Client', props<{ client: Client }>());
export const postClientSuccess = createAction(
	'[CLIENT] post client success',
	props<{ client: Client }>()
);
export const postClientError = createAction('[CLIENT] post client error', props<{ error: any }>());

export const getModuleOneClient = createAction(
	'[CLIENT] get module one client',
	props<{ pk: string; sk: string }>()
);
export const getModuleOneClientSuccess = createAction(
	'[CLIENT] get module one client success',
	props<{ module: ModuleClient[]; client: Client }>()
);
export const getModuleOneClientError = createAction(
	'[CLIENT] get module one client error',
	props<{ error: any }>()
);

export const deleteModuleOneClient = createAction(
	'[CLIENT] delete module client',
	props<{ data: ModuleClient; params: IPkSk }>()
);
export const deleteModuleOneClientSuccess = createAction(
	'[CLIENT] delete module client success',
	props<{ module: ModuleClient; client: Client }>()
);
export const deleteModuleOneClientError = createAction(
	'[CLIENT] delete module client error',
	props<{ error: any }>()
);

export const updateClient = createAction(
	'[CLIENT] update client',
	props<{ client: Client; params: any }>()
);
export const updateClientSuccess = createAction(
	'[CLIENT] update client success',
	props<{ client: Client }>()
);
export const updateClientError = createAction(
	'[CLIENT] update client error',
	props<{ error: any }>()
);

export const postModuleClient = createAction(
	'[CLIENT] Post module client',
	props<{ params: IPkSk; module: ModuleClient }>()
);
export const postModuleClientSuccess = createAction(
	'[CLIENT] Post module client success',
	props<{ module: ModuleClient; client: Client }>()
);
export const postModuleClientError = createAction(
	'[CLIENT] Post module client error',
	props<{ error: any }>()
);

export const updateModuleOneClient = createAction(
	'[CLIENT] update module client',
	props<{ module: ModuleClient; params: IPkSk }>()
);
export const updateModuleOneClientSuccess = createAction(
	'[CLIENT] update module client success',
	props<{ client: Client; module: ModuleClient }>()
);
export const updateModuleOneClientError = createAction(
	'[CLIENT] update module client error',
	props<{ error: any }>()
);

export const deleteClient = createAction(
	'[CLIENT] delete client',
	props<{ pk: string; sk: string }>()
);
export const deleteClientSuccess = createAction(
	'[CLIENT] delete client success',
	props<{ client: Client }>()
);
export const deleteClientError = createAction(
	'[CLIENT] delete client error',
	props<{ error: any }>()
);

export const getResourcesModuleClient = createAction(
	'[MODULE] get module client resources',
	props<{ url: string; pkClient: string; skClient: string }>()
);
export const getResourcesModuleClientSuccess = createAction(
	'[MODULE] get module client resources success',
	props<{
		resource: Resource[];
		pkClient: string;
		skClient: string;
		pagination: Pagination;
		pk: string;
	}>()
);
export const getResourcesModuleClientError = createAction(
	'[MODULE] get module client error',
	props<{ error: any }>()
);

export const getClientResourcesSearchModule = createAction(
	'[MODULE] get module search resources client',
	props<{ url: string; search: string; pkClient: string; skClient: string }>()
);
export const getClientResourcesSearchModuleSuccess = createAction(
	'[MODULE] get module search resources client success',
	props<{
		resource: Resource[];
		pagination: Pagination;
		pk: string;
		pkClient: string;
		skClient: string;
	}>()
);
export const getClientResourcesSearchModuleError = createAction(
	'[MODULE] get module search resources client error',
	props<{ error: any }>()
);
